export const REGISTER_FORM_NAME = 'register/REGISTER_FORM_NAME'
export const APPROVE_FORM_NAME = 'register/APPROVE_FORM_NAME';
export const DELETE_REQUEST_FORM_NAME = 'register/DELETE_REQUEST_NAME';
export const PASSWORD_FORM_NAME = 'register/PASSWORD_FORM_NAME';
export const CREATE_ACCOUNT_FORM_NAME = 'register/CREATE_ACCOUNT_FORM_NAME'
export const SET_HAS_CREATED_ACCOUNT = 'reviewers/SET_HAS_CREATED_ACCOUNT'
export const RESET_HAS_CREATED_ACCOUNT = 'reviewers/RESET_HAS_CREATED_ACCOUNT'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/register/actionTypes.ts